"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formsCommon_en_us = void 0;
function formsCommon_en_us() {
    return {
        "forms.validations.required": "required",
        "forms.validations.notdefined": "not defined",
        "forms.nodata": "No data available"
    };
}
exports.formsCommon_en_us = formsCommon_en_us;
